export type ChartTypeValue = 'Candlesticks' | 'OHLC Bars' | 'OHLC Bars (thick)' | 'HLC Bars' | 'HLC Bars (thick)' | 'Performance' | 'PerfChart' | 'Solid Line' | 'Solid Line (thin)' | 'Solid Line (thick)' | 'Dashed Line' | 'Dashed Line (thin)' | 'Dashed Line (thick)' | 'Dots' | 'Area' | 'Histogram' | 'Elder Impulse System' | 'EquiVolume' | 'CandleVolume' | 'Arms CandleVolume' | 'Invisible' | 'Heikin-Ashi' | 'Three Line Break' | 'Kagi' | 'Renko' | 'Cumulative';

export interface ChartTypeOption {
  title: string;
  shortTitle: string;
  value: ChartTypeValue;
  sharpCharts2TypeValue: string;
  sharpCharts2ArgsValue: string;
  sharpCharts2IsCandleBased: boolean;
  isNew: boolean;
};

export const CHART_TYPE_OPTION_CANDLESTICKS: ChartTypeOption = {
  title: 'Candlesticks',
  shortTitle: 'Candlesticks',
  value: 'Candlesticks',
  sharpCharts2TypeValue: 'candle',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: true,
  isNew: false
};
export const CHART_TYPE_OPTION_OHLC_BARS: ChartTypeOption = {
  title: 'OHLC Bars',
  shortTitle: 'OHLC Bars',
  value: 'OHLC Bars',
  sharpCharts2TypeValue: 'ohlc',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_OHLC_BARS_THICK: ChartTypeOption = {
  title: 'OHLC Bars (thick)',
  shortTitle: 'OHLC Bars (thick)',
  value: 'OHLC Bars (thick)',
  sharpCharts2TypeValue: 'ohlc',
  sharpCharts2ArgsValue: 'thick',
  sharpCharts2IsCandleBased: false,
  isNew: false
}
export const CHART_TYPE_OPTION_HLC_BARS: ChartTypeOption = {
  title: 'HLC Bars',
  shortTitle: 'HLC Bars',
  value: 'HLC Bars',
  sharpCharts2TypeValue: 'hlc',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_HLC_BARS_THICK: ChartTypeOption = {
  title: 'HLC Bars (thick)',
  shortTitle: 'HLC Bars (thick)',
  value: 'HLC Bars (thick)',
  sharpCharts2TypeValue: 'hlc',
  sharpCharts2ArgsValue: 'thick',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_PERFORMANCE_PERCENT: ChartTypeOption = {
  title: 'Performance (percent)',
  shortTitle: 'Performance',
  value: 'Performance',
  sharpCharts2TypeValue: 'performance',
  sharpCharts2ArgsValue: '1.5,solid',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_SOLID_LINE: ChartTypeOption = {
  title: 'Solid Line',
  shortTitle: 'Solid Line',
  value: 'Solid Line',
  sharpCharts2TypeValue: 'line',
  sharpCharts2ArgsValue: '1.5,solid',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_SOLID_LINE_THIN: ChartTypeOption = {
  title: 'Solid Line (thin)',
  shortTitle: 'Solid Line (thin)',
  value: 'Solid Line (thin)',
  sharpCharts2TypeValue: 'line',
  sharpCharts2ArgsValue: '1.0,solid',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_SOLID_LINE_THICK: ChartTypeOption = {
  title: 'Solid Line (thick)',
  shortTitle: 'Solid Line (thick)',
  value: 'Solid Line (thick)',
  sharpCharts2TypeValue: 'line',
  sharpCharts2ArgsValue: '2.0,solid',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_DASHED_LINE: ChartTypeOption = {
  title: 'Dashed Line',
  shortTitle: 'Dashed Line',
  value: 'Dashed Line',
  sharpCharts2TypeValue: 'line',
  sharpCharts2ArgsValue: '1.5,dashed',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_DASHED_LINE_THIN: ChartTypeOption = {
  title: 'Dashed Line (thin)',
  shortTitle: 'Dashed Line (thin)',
  value: 'Dashed Line (thin)',
  sharpCharts2TypeValue: 'line',
  sharpCharts2ArgsValue: '1.0,dashed',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_DASHED_LINE_THICK: ChartTypeOption = {
  title: 'Dashed Line (thick)',
  shortTitle: 'Dashed Line (thick)',
  value: 'Dashed Line (thick)',
  sharpCharts2TypeValue: 'line',
  sharpCharts2ArgsValue: '2.0,dashed',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_DOTS: ChartTypeOption = {
  title: 'Dots',
  shortTitle: 'Dots',
  value: 'Dots',
  sharpCharts2TypeValue: 'dots',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_AREA: ChartTypeOption = {
  title: 'Area',
  shortTitle: 'Area',
  value: 'Area',
  sharpCharts2TypeValue: 'area',
  sharpCharts2ArgsValue: '0.0,0.0',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_HISTOGRAM: ChartTypeOption = {
  title: 'Histogram',
  shortTitle: 'Histogram',
  value: 'Histogram',
  sharpCharts2TypeValue: 'hist',
  sharpCharts2ArgsValue: '0.0,0.0',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_ELDER_IMPULSE_SYSTEM: ChartTypeOption = {
  title: 'Elder Impulse System',
  shortTitle: 'Elder Impulse System',
  value: 'Elder Impulse System',
  sharpCharts2TypeValue: 'ohlcelder',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_EQUI_VOLUME: ChartTypeOption = {
  title: 'EquiVolume',
  shortTitle: 'EquiVolume',
  value: 'EquiVolume',
  sharpCharts2TypeValue: 'equivolume',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_CANDLE_VOLUME: ChartTypeOption = {
  title: 'CandleVolume',
  shortTitle: 'CandleVolume',
  value: 'CandleVolume',
  sharpCharts2TypeValue: 'candlevolume',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: true,
  isNew: false
};
export const CHART_TYPE_OPTION_ARMS_CANDLE_VOLUME: ChartTypeOption = {
  title: 'Arms CandleVolume',
  shortTitle: 'Arms CandleVolume',
  value: 'Arms CandleVolume',
  sharpCharts2TypeValue: 'armscandlevolume',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: true,
  isNew: false
};
export const CHART_TYPE_OPTION_INVISIBLE: ChartTypeOption = {
  title: 'Invisible',
  shortTitle: 'Invisible',
  value: 'Invisible',
  sharpCharts2TypeValue: 'invisible',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_PERF_CHART: ChartTypeOption = {
  title: 'PerfChart',
  shortTitle: 'PerfChart',
  value: 'PerfChart',
  sharpCharts2TypeValue: '',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: true
};
export const CHART_TYPE_OPTION_HEIKIN_ASHI: ChartTypeOption = {
  title: 'Heikin-Ashi',
  shortTitle: 'Heikin-Ashi',
  value: 'Heikin-Ashi',
  sharpCharts2TypeValue: 'heikin',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: true,
  isNew: false
};
export const CHART_TYPE_OPTION_THREE_LINE_BREAK: ChartTypeOption = {
  title: 'Three Line Break',
  shortTitle: 'Three Line Break',
  value: 'Three Line Break',
  sharpCharts2TypeValue: 'tlb',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: true,
  isNew: false
};
export const CHART_TYPE_OPTION_KAGI: ChartTypeOption = {
  title: 'Kagi',
  shortTitle: 'Kagi',
  value: 'Kagi',
  sharpCharts2TypeValue: 'kagi',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: false,
  isNew: false
};
export const CHART_TYPE_OPTION_RENKO: ChartTypeOption = {
  title: 'Renko',
  shortTitle: 'Renko',
  value: 'Renko',
  sharpCharts2TypeValue: 'renko',
  sharpCharts2ArgsValue: '',
  sharpCharts2IsCandleBased: true,
  isNew: false
};
export const CHART_TYPE_OPTION_CUMULATIVE: ChartTypeOption = {
  title: 'Cumulative',
  shortTitle: 'Cumulative',
  value: 'Cumulative',
  sharpCharts2TypeValue: 'cumulative',
  sharpCharts2ArgsValue: '1.5,solid',
  sharpCharts2IsCandleBased: false,
  isNew: false
};

export const DEFAULT_CHART_TYPE_OPTION: ChartTypeOption = CHART_TYPE_OPTION_OHLC_BARS_THICK;

export interface ChartTypeOptionGroup {
  groupTitle: string;
  groupId: string;
  chartTypeOptions: ChartTypeOption[];
};

export const CHART_TYPE_OPTION_GROUPS: ChartTypeOptionGroup[] = [
  {
    groupTitle: '',
    groupId: 'Standard Chart Types',
    chartTypeOptions: [
      CHART_TYPE_OPTION_CANDLESTICKS,
      CHART_TYPE_OPTION_OHLC_BARS,
      CHART_TYPE_OPTION_OHLC_BARS_THICK,
      CHART_TYPE_OPTION_HLC_BARS,
      CHART_TYPE_OPTION_HLC_BARS_THICK,
      CHART_TYPE_OPTION_PERFORMANCE_PERCENT,
      CHART_TYPE_OPTION_SOLID_LINE,
      CHART_TYPE_OPTION_SOLID_LINE_THIN,
      CHART_TYPE_OPTION_SOLID_LINE_THICK,
      CHART_TYPE_OPTION_DASHED_LINE,
      CHART_TYPE_OPTION_DASHED_LINE_THIN,
      CHART_TYPE_OPTION_DASHED_LINE_THICK,
      CHART_TYPE_OPTION_DOTS,
      CHART_TYPE_OPTION_AREA,
      CHART_TYPE_OPTION_HISTOGRAM,
      CHART_TYPE_OPTION_ELDER_IMPULSE_SYSTEM,
      CHART_TYPE_OPTION_EQUI_VOLUME,
      CHART_TYPE_OPTION_CANDLE_VOLUME,
      CHART_TYPE_OPTION_ARMS_CANDLE_VOLUME,
      CHART_TYPE_OPTION_INVISIBLE
    ]
  },
  {
    groupTitle: 'COMPARISON CHARTS',
    groupId: 'Comparison Charts',
    chartTypeOptions: [
      CHART_TYPE_OPTION_PERF_CHART
    ]
  },
  {
    groupTitle: 'AGGREGATED CHARTS',
    groupId: 'Aggregated Charts',
    chartTypeOptions: [
      CHART_TYPE_OPTION_HEIKIN_ASHI,
      CHART_TYPE_OPTION_THREE_LINE_BREAK,
      CHART_TYPE_OPTION_KAGI,
      CHART_TYPE_OPTION_RENKO,
      CHART_TYPE_OPTION_CUMULATIVE
    ]
  }
];

export const CHART_TYPE_OPTIONS_ARRAY = [
  CHART_TYPE_OPTION_CANDLESTICKS,
  CHART_TYPE_OPTION_OHLC_BARS,
  CHART_TYPE_OPTION_OHLC_BARS_THICK,
  CHART_TYPE_OPTION_HLC_BARS,
  CHART_TYPE_OPTION_HLC_BARS_THICK,
  CHART_TYPE_OPTION_PERFORMANCE_PERCENT,
  CHART_TYPE_OPTION_SOLID_LINE,
  CHART_TYPE_OPTION_SOLID_LINE_THIN,
  CHART_TYPE_OPTION_SOLID_LINE_THICK,
  CHART_TYPE_OPTION_DASHED_LINE,
  CHART_TYPE_OPTION_DASHED_LINE_THIN,
  CHART_TYPE_OPTION_DASHED_LINE_THICK,
  CHART_TYPE_OPTION_DOTS,
  CHART_TYPE_OPTION_AREA,
  CHART_TYPE_OPTION_HISTOGRAM,
  CHART_TYPE_OPTION_ELDER_IMPULSE_SYSTEM,
  CHART_TYPE_OPTION_EQUI_VOLUME,
  CHART_TYPE_OPTION_CANDLE_VOLUME,
  CHART_TYPE_OPTION_ARMS_CANDLE_VOLUME,
  CHART_TYPE_OPTION_INVISIBLE,
  CHART_TYPE_OPTION_PERF_CHART,
  CHART_TYPE_OPTION_HEIKIN_ASHI,
  CHART_TYPE_OPTION_THREE_LINE_BREAK,
  CHART_TYPE_OPTION_KAGI,
  CHART_TYPE_OPTION_RENKO,
  CHART_TYPE_OPTION_CUMULATIVE
];

export function getChartTypeObjFromChartTypeValue(chartTypeValue: string): ChartTypeOption {
  return CHART_TYPE_OPTIONS_ARRAY.find(ct => ct.value === chartTypeValue) ?? DEFAULT_CHART_TYPE_OPTION;
}
